module.exports = __webpack_public_path__ + "img/icon-location.svg";